<!-- <div id="cover-spin" ></div> -->
<div class="loaderIcon" *ngIf="!isPaymentProcessed">
    <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
</div>
<div class="loaderIcon" *ngIf="isPaymentProcessed">
    <figure>
        <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
        <figcaption *ngIf="isPaymentProcessed" class="initiatedvoid">Please do not refresh the page or click the back button while your payment is being processed</figcaption>
       </figure>
</div>
